import { PRODUCT_CONFIG } from '../config/ProductConfig';

export class AgeCalculatorService {
  static calculateAge(dateOfBirth: Date): number {
    const birthDate = new Date(dateOfBirth);
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      return age - 1;
    }

    return age;
  }

  static calculateAgeInMonths(dateOfBirth: Date): number {
    const birthDate = new Date(dateOfBirth);
    const today = new Date();

    const years = today.getFullYear() - birthDate.getFullYear();
    const months = today.getMonth() - birthDate.getMonth();
    const days = today.getDate() - birthDate.getDate();

    let totalMonths = years * 12 + months;

    // Adjust if birth day hasn't occurred yet this month
    if (days < 0) {
      totalMonths--;
    }

    return totalMonths;
  }

  static isPediatric(dateOfBirth: Date): boolean {
    const ageInMonths = this.calculateAgeInMonths(dateOfBirth);
    return ageInMonths <= PRODUCT_CONFIG.ageThresholds.pediatricMaxAgeMonths;
  }

  static isUnder45(dateOfBirth: Date): boolean {
    const age = this.calculateAge(dateOfBirth);
    return age <= PRODUCT_CONFIG.ageThresholds.under45MaxAge;
  }

  static isOver60(dateOfBirth: Date): boolean {
    const age = this.calculateAge(dateOfBirth);
    return age >= PRODUCT_CONFIG.ageThresholds.over60MinAge;
  }

  static isMinor(dateOfBirth: Date): boolean {
    const age = this.calculateAge(dateOfBirth);
    return age <= PRODUCT_CONFIG.ageThresholds.minorMaxAge;
  }
}
